module.exports = __webpack_public_path__ + "img/osmanthus_2.dc81e07e.png";